export default __webpack_public_path__ + "static/media/plegable.07adad6a.png";